import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSwitchComponent } from './input-switch.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [InputSwitchComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [InputSwitchComponent]
})
export class InputSwitchModule { }
